const LEVELS = {
  1: 0,
  2: 100,
  3: 300,
  4: 600,
  5: 1000,
  6: 1500,
  7: 2000,
  8: 2500,
  9: 3000,
  10: 3500,
  11: 4000,
  12: 4500,
  13: 5000,
  14: 5500,
  15: 6000,
  16: 6500,
  17: 7000,
  18: 7500,
  19: 8000,
  20: 8500,
  21: 9000,
  22: 9500,
  23: 10000,
  24: 10500,
  25: 11000,
};

export const getLevel = (xp: number) => {
  const levelEntries = Object.entries(LEVELS).map(([level, xp]) => ({
    level: Number(level),
    xp,
  }));

  let level = 1;
  let percentage = 0;

  for (let i = 0; i < levelEntries.length - 1; i++) {
    const curr = levelEntries[i];
    const next = levelEntries[i + 1];

    if (xp < next.xp) {
      level = curr.level;
      const range = next.xp - curr.xp;
      percentage = ((xp - curr.xp) / range) * 100;
      break;
    }
  }

  // Handle max level
  if (xp >= LEVELS[25]) {
    level = 25;
    percentage = 100;
  }

  return {
    level,
    percentage: Math.floor(percentage),
  };
};

// export const API = "https://api-test.tapsphere.io/api";
export const API = "https://api.playops.tapsphere.io/api";
// export const API = "http://localhost:10041/api";

// export const GROUP_CHAT_ID = -1003133259702;
// export const DECODER_THREAD_ID = 6;
// export const LOREKEEPER_THREAD_ID = 8;
// export const SIGNAL_BOOSTER_THREAD_ID = 2;
// export const FEED_WATCHER_THREAD_ID = 4;
// export const NETWORKING_EVENT_THREAD_ID = 18;
// export const UI_UX_ARCHITECT_THREAD_ID = 16;
// export const INTERFACE_ARCHITECT_THREAD_ID = 12;
// export const SYSTEM_BUILDER_THREAD_ID = 14;
// export const SOCIAL_MEDIA_HANDLES_THREAD_ID = 10;

export const GROUP_CHAT_ID = -1002731972620;
export const DECODER_THREAD_ID = 8;
export const LOREKEEPER_THREAD_ID = 9;
export const SIGNAL_BOOSTER_THREAD_ID = 10;
export const FEED_WATCHER_THREAD_ID = 17;
export const NETWORKING_EVENT_THREAD_ID = 18;
export const UI_UX_ARCHITECT_THREAD_ID = 3399;
export const INTERFACE_ARCHITECT_THREAD_ID = 3397;
export const SYSTEM_BUILDER_THREAD_ID = 3398;
export const SOCIAL_MEDIA_HANDLES_THREAD_ID = 47;
